/** Nested Mercari categories, same paths Vendoo shows when you click each category. */

export function mercariCategoryTree(paths) {
  const root = { name: "All", path: "", children: [] };
  const index = new Map([["", root]]);
  for (const full of paths) {
    const parts = String(full || "").split(" > ").filter(Boolean);
    let parentPath = "";
    for (let i = 0; i < parts.length; i += 1) {
      const path = parts.slice(0, i + 1).join(" > ");
      if (!index.has(path)) {
        const node = { name: parts[i], path, children: [] };
        index.set(path, node);
        index.get(parentPath).children.push(node);
      }
      parentPath = path;
    }
  }
  for (const node of index.values()) {
    node.children.sort((a, b) => a.name.localeCompare(b.name, undefined, { sensitivity: "base" }));
  }
  return root;
}

export function mercariCategoryNode(tree, path) {
  if (!path) return tree;
  const parts = String(path).split(" > ").filter(Boolean);
  let cursor = tree;
  for (const part of parts) {
    const next = cursor.children.find((child) => child.name === part);
    if (!next) return null;
    cursor = next;
  }
  return cursor;
}

/** Open the list on the parent of a leaf, or inside a category that has subcategories. */
export function mercariCategoryStack(tree, path) {
  const node = mercariCategoryNode(tree, path);
  if (!node || node === tree) return [];
  const parts = String(path).split(" > ").filter(Boolean);
  const stack = [];
  let cursor = tree;
  for (const part of parts) {
    const next = cursor.children.find((child) => child.name === part);
    if (!next) break;
    stack.push(next);
    cursor = next;
  }
  if (cursor.children.length === 0 && stack.length) stack.pop();
  return stack;
}
